import { render, staticRenderFns } from "./CreateChallengeModal.vue?vue&type=template&id=21cf1722&scoped=true&"
import script from "./CreateChallengeModal.vue?vue&type=script&lang=js&"
export * from "./CreateChallengeModal.vue?vue&type=script&lang=js&"
import style0 from "./CreateChallengeModal.vue?vue&type=style&index=0&id=21cf1722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cf1722",
  null
  
)

export default component.exports